import { createNestHull, disposeNestHull } from '../neuralMaterials';

export function createHullController({ nodeGroup, hullByHubId }) {
  function reconcileHulls(g) {
    const next = new Set();
    (g.hulls || []).forEach((hull) => {
      next.add(hull.hubId);
      let ring = hullByHubId.get(hull.hubId);
      if (!ring) {
        ring = createNestHull(hull.tint);
        nodeGroup.add(ring);
        hullByHubId.set(hull.hubId, ring);
      }
      ring.userData.exiting = false;
      ring.userData.target = hull;
      ring.material.color.set(hull.tint);
    });
    hullByHubId.forEach((ring, hubId) => {
      if (!next.has(hubId)) ring.userData.exiting = true;
    });
  }

  /** Called every frame: ease rings toward their layout target and fade in/out. */
  function updateHulls(lerp) {
    const dead = [];
    hullByHubId.forEach((ring, hubId) => {
      const t = ring.userData.target;
      if (t) {
        ring.position.x += (t.cx - ring.position.x) * lerp;
        ring.position.y += (t.cy - ring.position.y) * lerp;
        ring.position.z = t.z;
        // Gaussian falls to ~nothing at the texture edge, so overscale past the hull radius.
        const s = ring.scale.x + (t.r * 1.7 - ring.scale.x) * lerp;
        ring.scale.setScalar(Math.max(s, 0.001));
      }
      const goal = ring.userData.exiting ? 0 : ring.userData.targetOpacity;
      const op = ring.material.opacity + (goal - ring.material.opacity) * lerp;
      ring.material.opacity = op;
      ring.visible = op > 0.005;
      if (ring.userData.exiting && op < 0.005) dead.push(hubId);
    });
    dead.forEach((hubId) => {
      const ring = hullByHubId.get(hubId);
      nodeGroup.remove(ring);
      disposeNestHull(ring);
      hullByHubId.delete(hubId);
    });
  }

  return { reconcileHulls, updateHulls };
}
